module.exports = __webpack_public_path__ + "media/account-app/features/settings/credit-card-icon-set@2x-35942135028a29de1660c24c7e3fb071.png";